// Tiny module-level cache that ClientsProvider keeps populated and that
// the legacy synchronous loadClients() / saveClients() shims read from.
//
// This exists so we don't have to async-refactor every old caller in
// the same change. New code should use useClients() from ClientsContext.

let _cache = [];
const _listeners = new Set();

export function setClientsCache(arr) {
  _cache = Array.isArray(arr) ? arr : [];
  for (const fn of _listeners) {
    try { fn(_cache); } catch {}
  }
}

export function getClientsCache() {
  return _cache;
}

export function subscribeClientsCache(fn) {
  _listeners.add(fn);
  return () => _listeners.delete(fn);
}
